import useTypeTracking from '../../../analytics';
import { IAppExtensionItem } from '../../types/appExtension';

enum Extension {
    EVENT_EXTENSION = 'EVENT_EXTENSION',
    SESSION_EXTENSION = 'SESSION_EXTENSION',
}

enum Action {
    OPEN_APP_MODAL = 'OPEN_APP_MODAL',
    OPEN_APP_TAB = 'OPEN_APP_TAB',
}

export const useAppExtensionTracking = (sessionId: number, extension: IAppExtensionItem) => {
    const { Track, trackSystemEvent } = useTypeTracking({
        data: {
            description: {
                location: 'VENUE_TOOL_BAR',
                app_name: extension?.name,
                app_category: extension?.category,
                icon_clicked: sessionId ? Extension.SESSION_EXTENSION : Extension.EVENT_EXTENSION,
                session_id: sessionId ? sessionId : null,
            },
            category: 'APP_INTERACTION',
        },
    });

    const trackAppOpenModal = () => {
        trackSystemEvent({
            action: Action.OPEN_APP_MODAL,
        });
    };

    const trackAppOpenNewTab = () => {
        trackSystemEvent({
            action: Action.OPEN_APP_TAB,
        });
    };

    return {
        AppExtensionTrack: Track,
        trackAppOpenModal,
        trackAppOpenNewTab,
    };
};
